import { useContext } from 'react';
import FieldContext from '../../../FieldContext';
import ModelsContext from '../../../../../../ModelsContext';
import useApi from '@/lib/api/useApi';
import { type EditorField } from '@/lib/types';
import SelectedModelIdContext from '@/pages/EditorPage/ChallengeModelsEditor/SelectedModelIdContext';

const useSwapPositionsWithField = (): ((
  fieldToSwapWith: EditorField,
) => Promise<void>) => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { field } = useContext(FieldContext);

  const swapFieldPositions = async (
    fieldToSwapWith: EditorField,
  ): Promise<void> => {
    await api.post(
      `editor/challenge-model/fields/${field!.id}/position/swap/${
        fieldToSwapWith.id
      }`,
    );

    setModels(models => {
      models[selectedModelId].fields[field!.id].position =
        fieldToSwapWith.position;
      models[selectedModelId].fields[fieldToSwapWith.id].position =
        field!.position;
    });
  };

  return swapFieldPositions;
};

export default useSwapPositionsWithField;
